<div *ngIf="!isLoading && hasData">
  <ngx-charts-bar-vertical
    #chart
    [results]="results"
    [scheme]="{ domain: [this.color] }"
    [xAxis]="xAxis"
    [yAxis]="yAxis"
    [showDataLabel]="showDataLabel"
    [roundEdges]="roundEdges"
    [showGridLines]="showGridLines"
    [rotateXAxisTicks]="rotateXAxisTicks"
    [animations]="false"
    [yAxisTickFormatting]="yAxisTickFormatting"
    [barPadding]="30"
    (select)="select.emit($event)"
  >
  </ngx-charts-bar-vertical>
</div>
<p *ngIf="!isLoading && !hasData">
  {{ 'VERTICAL_BAR.NO_DATA' | translate }}
</p>
<ngx-skeleton-loader *ngIf="isLoading" [theme]="{ height: '100%', width: '100%', margin: '0' }"></ngx-skeleton-loader>
